import React from "react";

import "./ButtonLike.scss";

export type ButtonLikeProps = {
  cx?: string;
  outline?: boolean;
};

export const ButtonLike: React.FC<ButtonLikeProps> = ({
  cx = "",
  children,
  outline = false,
}) => {
  return (
    <div className={`ButtonLike ${cx} ${outline ? "outline" : ""}`}>
      {children}
    </div>
  );
};
